<!-- EDIT MODE -->

<div *ngIf="editable; else previewMode">

  <table class="w-full border">

    <thead>
      <tr>

        <th
          *ngFor="let col of tableConfig.columns"
          class="border p-2">

          {{ col.label | translate }}

        </th>

        <th class="border p-2">
          {{ 'COMMON.ACTION' | translate }}
        </th>

      </tr>
    </thead>

    <tbody>

      <tr
        *ngFor="let row of tableConfig.data; let i = index">

        <td
          *ngFor="let col of tableConfig.columns"
          class="border p-2">

          <input
            [(ngModel)]="row[col.key]"
            class="border rounded p-2 w-full">

        </td>

        <td class="border p-2">

          <button
            type="button"
            (click)="deleteRow(i)"
            class="section-delete-btn section-delete-btn-sm">

            {{ 'COMMON.DELETE' | translate }}

          </button>

        </td>

      </tr>

    </tbody>

  </table>

  <button
    type="button"
    (click)="addRow()"
    class="section-add-btn mt-3">

    {{ 'CREDIT_SECTION.ADD_ROW' | translate }}

  </button>

</div>

<!-- PREVIEW MODE -->

<ng-template #previewMode>

  <app-table
    [columns]="tableConfig.columns"
    [data]="tableConfig.data">
  </app-table>

</ng-template>